import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { AlbumSort } from './album-list';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-album-sort-controls',
  template: `
    <label class="control">
      <span>Sort</span>
      <select (change)="sortChange.emit($any($event.target).value)">
        <option value="top" [selected]="sort() === 'top'">Most popular</option>
        <option value="newest" [selected]="sort() === 'newest'">Newest first</option>
        <option value="oldest" [selected]="sort() === 'oldest'">Oldest first</option>
      </select>
    </label>
    <label class="control">
      <span>Year</span>
      <select (change)="yearChange.emit(+$any($event.target).value)">
        <option value="0" [selected]="year() === 0">Any year</option>
        @for (y of years(); track y) {
        <option [value]="y" [selected]="y === year()" [disabled]="availableYears() !== null && !availableYears()!.has(y) && y !== year()">{{y}}</option>
        }
      </select>
    </label>
  `,
  styles: [`
    :host { display: contents; }
    .control { display: inline-flex; align-items: center; gap: 6px; font-size: 0.85rem; }
    select { font: inherit; padding: 5px 8px; border: 1px solid rgba(0,0,0,.25); border-radius: 6px; background: #fff; }
  `]
})
export class AlbumSortControlsComponent {
  sort = input.required<AlbumSort>();
  year = input.required<number>();
  years = input.required<number[]>();
  /** Years that have at least one album; other years are disabled. null = not known yet, so all stay enabled. */
  availableYears = input<ReadonlySet<number> | null>(null);
  sortChange = output<AlbumSort>();
  yearChange = output<number>();
}
